<script setup lang="ts">
import { computed } from 'vue'
import { formatCurrency } from '~/utils/formatters'
import { useGlobalSalaryPeriod } from '~/composables/useGlobalSalaryPeriod'
import { stateOptions } from '~/utils/states'

const props = defineProps({
  state: {
    type: Object,
    required: true
  },
  position: {
    type: Object,
    required: true
  },
  formattedSalary: {
    type: String,
    default: null
  }
})
const { adjustValueForPeriod } = useGlobalSalaryPeriod()
const stateName = computed(() => {
  const stateCode = props.state.state
  const stateInfo = stateOptions.find(s => s.code === stateCode)
  return stateInfo ? stateInfo.label : stateCode
})
const formattedSalary = computed(() => {
  if (props.formattedSalary) return props.formattedSalary
  return formatCurrency(adjustValueForPeriod(props.state.median_salary))
})
</script>

<template>
  <div
    class="tooltip absolute z-50 bg-white shadow-lg rounded p-2 border text-sm"
    :style="{ left: `${position.x}px`, top: `${position.y}px` }"
  >
    <div class="font-semibold">
      {{ stateName }}
    </div>
    <div>{{ formattedSalary }}</div>
  </div>
</template>

<style scoped>
.tooltip {
  transform: translate(-50%, -100%);
  margin-top: -10px;
  min-width: 120px;
}
</style>
